import { Parcel } from '~api/som';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { Dimensions } from '~src/components/Dimensions/Dimensions';
import { Weight } from '~src/components/Weight/Weight';
import { useTranslation } from '~src/i18n/use-translation';

import { ShipmentDetails } from '../types';
import { ConsignmentItem } from './consignment-item';

export interface ConsignmentProps {
  shipment: ShipmentDetails;
}

interface ParcelProps {
  parcel: Parcel;
}

function ParcelCard({ parcel }: ParcelProps) {
  const { t } = useTranslation();

  const items = parcel.contents?.goods ?? [];

  return (
    <Card.Content key={parcel.id}>
      <ListLayout.Column>
        <ListLayout.Column>
          <ListLayout.Stack>
            <ListLayout.SubRow>
              <ListLayout.PrimaryText>{t('common.parcel')}</ListLayout.PrimaryText>
            </ListLayout.SubRow>
            <ListLayout.SubRow gap="lg">
              <ListLayout.SecondaryText>
                {items.length} {t(items.length === 1 ? 'common.item' : 'common.items')}
              </ListLayout.SecondaryText>
              <ListLayout.SecondaryText>
                <Weight weight={parcel.weight} />
              </ListLayout.SecondaryText>
              <ListLayout.SecondaryText>
                <Dimensions dimensions={parcel.dimensions} />
              </ListLayout.SecondaryText>
            </ListLayout.SubRow>
          </ListLayout.Stack>
        </ListLayout.Column>
        <ListLayout.Column>
          <ListLayout.Row css={{ marginLeft: '16px' }}>
            <ListLayout.Column css={{ width: '100%' }}>
              {items.map((item, i) => (
                <ConsignmentItem item={item} key={`item-${i}`} />
              ))}
            </ListLayout.Column>
          </ListLayout.Row>
        </ListLayout.Column>
      </ListLayout.Column>
    </Card.Content>
  );
}

export function Consignment({ shipment }: ConsignmentProps) {
  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('shipments.consignment.details')}</Card.Header>
      {shipment.parcels?.map(parcel => (
        <ParcelCard parcel={parcel} key={parcel.id} />
      ))}
    </Card.Wrapper>
  );
}
